<script setup lang="ts">
import { ModalsContainer } from 'vue-final-modal'

const { attachLoggedUser } = useIntercomHelpers();
const { status } = useAuth();
const route = useRoute();
const isJobPreview = computed(() => route.name?.toString().includes('job-preview'))

watchEffect(() => {
  if(status.value === 'authenticated') {
    attachLoggedUser();
  }
});

</script>
<template>
  <Menu v-if="!isJobPreview" />
  <slot />
  <Footer></Footer>
  <ModalsContainer/>
</template>
